export const StarColorType = {
  BLUE: '#2563eb',
  GRAY: '#E2E8F0',
  TRANSPARENT: 'transparent'
};